var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('v-sheet',{staticClass:"pa-10",attrs:{"min-height":"70vh","rounded":"lg"}},[_c('p',[_vm._v("Privacy policy")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }